import { Link } from "react-router-dom";
import { posts } from "@/mocks/posts";

const durations = ["04:12", "03:26", "05:08", "02:47", "06:15", "04:53"];

export default function VideoRail() {
  const videos = posts.filter((post) => post.category === "shipin");

  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {videos.map((post, index) => (
        <li key={post.id}>
          <Link
            to={`/post/${post.id}`}
            className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="relative w-full aspect-video overflow-hidden bg-foreground-950">
              <img
                src={post.cover}
                alt={`${post.title} - 网爆吃瓜二创视频`}
                title={`${post.title} - 网爆吃瓜二创视频`}
                className="w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-foreground-950/25 group-hover:bg-foreground-950/10 transition-colors"></div>
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="w-12 h-12 rounded-full bg-background-50/95 flex items-center justify-center text-primary-600 text-xl group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill"></i>
                </span>
              </span>
              <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-foreground-950/80 text-background-100 text-xs">
                {durations[index % durations.length]}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {post.title}
              </h3>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                <span className="whitespace-nowrap">{post.author}</span>
                <span className="flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </span>
                  {post.views}
                </span>
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}